export default function BigPrimaryButton({
  title,
  onClick,
  disabled,
  buttonClassName = "years-content-action-button bg-primary-button-dark-blue px-8 rounded-3xl py-3 border-4 border-yellow-400",
  textClassName = "font-mali font-bold text-3xl text-white",
}) {
  return (
    <button
      disabled={disabled}
      className={buttonClassName}
      onClick={onClick}
    >
      <span className={textClassName}>{title}</span>
    </button>
  );
}
